import { render } from "./WCProductCard.vue?vue&type=template&id=f33c1f98&scoped=true"
import script from "./WCProductCard.vue?vue&type=script&lang=js"
export * from "./WCProductCard.vue?vue&type=script&lang=js"

import "./WCProductCard.vue?vue&type=style&index=0&id=f33c1f98&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f33c1f98"]])

export default __exports__